import React from 'react';
import AnimatedLogo from '../AnimatedLogo';

const LOGO_BOX_STYLE = { width: '48px', height: '14px' };
const LOGO_SCALE_STYLE = { transform: 'scale(0.2)', transformOrigin: 'left center' };

export const MockupNavbar = () => (
  <div className="absolute top-0 left-0 right-0 px-2 sm:px-3 md:px-4 pt-2 sm:pt-2.5 md:pt-3 pb-1.5 flex items-center justify-between z-10">
    <div className="overflow-hidden flex items-center" style={LOGO_BOX_STYLE} data-testid="mockup-animated-logo">
      <div className="origin-left flex-shrink-0" style={LOGO_SCALE_STYLE}>
        <AnimatedLogo />
      </div>
    </div>
    <div className="space-y-[2px] sm:space-y-0.5">
      <div className="w-3 sm:w-4 h-[1.5px] sm:h-0.5 bg-white rounded-full" />
      <div className="w-3 sm:w-4 h-[1.5px] sm:h-0.5 bg-white rounded-full" />
    </div>
  </div>
);
